import { render, staticRenderFns } from "./CatalogoProdutos.vue?vue&type=template&id=43d2cf26&scoped=true"
import script from "./CatalogoProdutos.vue?vue&type=script&lang=js"
export * from "./CatalogoProdutos.vue?vue&type=script&lang=js"
import style0 from "./CatalogoProdutos.vue?vue&type=style&index=0&id=43d2cf26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d2cf26",
  null
  
)

export default component.exports